import React, { useState, useEffect } from 'react';
import { Collection, Flex, Heading, View } from "@aws-amplify/ui-react";
import { AnswerCard } from '../ui-components';

const Results = ({ questions, answers }) => {
    const [answers2, setAnswers2] = useState([]);

    useEffect(() => {
        if (answers) {
            setAnswers2(answers);
        }
    }, [answers]);

    const score = answers2.reduce((acc, answer, index) => {
        return acc + (answer === questions[index].correct_answer ? 1 : 0);
    }, 0);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <View id="results">
            <h2>Votre score : {score} / {questions.length}</h2>
            <Heading level={3}>Réponses</Heading>
            <Collection items={questions} type="list" direction="column" gap="1rem">
                {(question, index) => (
                    <AnswerCard
                        className={`question_index_to_scroll_${index}`}
                        QuestionNumber={index + 1}
                        Question={question.question}
                        YourAnswer={answers2[index] || "Pas de réponse"}
                        CorrectAnswer={question.correct_answer}
                        Explanation={question.explanation}
                        isCorrect={answers2[index] === question.correct_answer}
                        overrides={
                            {
                                Question: {
                                    width: "95%",

                                },
                                AnswerCard: {
                                    width: "100%",

                                }
                            }

                        }
                    />
                )}
            </Collection>
            <View id="scroll-to-top-container">
                <button
                    className="mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect mdl-button--colored"
                    id="scroll-to-top-btn"
                    onClick={scrollToTop}
                >
                    <i className="material-icons">arrow_upward</i>
                </button>
            </View>
        </View>
    );
};

export default Results;